var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('pop-dialog', _vm._g(_vm._b({
    attrs: {
      "height": "auto",
      "width": "80%",
      "showClose": false,
      "closeModel": false
    }
  }, 'pop-dialog', _vm.$attrs, false), _vm.$listeners), [_c('div', {
    staticClass: "pop-main"
  }, [_c('div', {
    staticClass: "pop-main-box",
    on: {
      "click": _vm.cancelFn
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "title-l"
  }), _c('div', {
    staticClass: "title-text"
  }, [_vm._v(_vm._s(_vm.title))]), _c('div', {
    staticClass: "title-r"
  })]), _c('div', {
    staticClass: "pop__intro"
  }, [_vm._v(_vm._s(_vm.message))]), _c('div', {
    staticClass: "pop__next__intro"
  }, [_c('div', {
    staticClass: "pop__next__intro-text"
  }, [_vm._v(_vm._s(_vm.$lang("Ready to challenge the")))]), _c('div', {
    staticClass: "pop__next__intro-level"
  }, [_vm._v("level " + _vm._s(_vm.nextLevel))])]), _c('div', {
    staticClass: "btns"
  }, [_c('div', {
    staticClass: "btn btn-confirm",
    style: {
      background: _vm.themeMainColor(_vm.theme).main
    },
    on: {
      "click": _vm.confirmFn
    }
  }, [_vm._v(_vm._s(_vm.nextBtnText))])])])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };